import { Grid, InputAdornment } from "@material-ui/core";
import React from "react";

import { Form } from "../../../../components/form";
import { FormButton } from "../../../../components/form_button";
import { TextInput } from "../../../../components/text_input";
import { IFormProps } from "../../../../core/models";
import { isPending } from "../../../../core/redux";
import { fixAmount } from "../../../../core/utils";
import { IProductForm, productFormValidation } from "../../data/entities";
import { calcCleanWeight } from "../../utils";

interface IProps extends IFormProps<IProductForm> {}

export const ProductForm: React.FC<IProps> = (props: IProps) => {
  const { branch, submitTitle } = props;
  const loading = isPending(branch);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <Form<IProductForm>
          {...props}
          initialValues={{
            name: "",
            defaultWastePercent: 0,
            wastePercent: 0,
            dirtyWeight: 0,
            price: 0,
            totalPrice: 0,
          }}
          validationSchema={productFormValidation}
        >
          {({ values, setFieldValue }) => (
            <>
              <TextInput label="Ad" name="name" />

              <TextInput
                label="Çirkli çəki"
                name="dirtyWeight"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">Kq</InputAdornment>,
                }}
              />

              <TextInput
                label="Orta itki faizi"
                name="defaultWastePercent"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">%</InputAdornment>,
                }}
                onChange={(e) => {
                  const val = parseFloat(e.target.value);
                  setFieldValue(`wastePercent`, val);
                }}
              />

              <TextInput
                label="İtki faizi"
                name="wastePercent"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">%</InputAdornment>,
                }}
              />

              <TextInput
                label="Cəm qiymət"
                name="totalPrice"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">AZN</InputAdornment>,
                }}
                onChange={(e) => {
                  const val = parseFloat(e.target.value);
                  setFieldValue(
                    `price`,
                    fixAmount(
                      val / calcCleanWeight({ dirtyWeight: values.dirtyWeight, wastePercent: values.wastePercent }),
                      4,
                    ),
                  );
                }}
              />

              <TextInput
                label="Qiymət"
                name="price"
                type="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">AZN</InputAdornment>,
                }}
                onChange={(e) => {
                  const val = parseFloat(e.target.value);
                  setFieldValue(
                    `totalPrice`,
                    fixAmount(
                      val * calcCleanWeight({ dirtyWeight: values.dirtyWeight, wastePercent: values.wastePercent }),
                    ),
                  );
                }}
              />

              <FormButton label={submitTitle} loading={loading} />
            </>
          )}
        </Form>
      </Grid>
    </Grid>
  );
};
